import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { VirtualConnectionTableLineageCountsFragmentGql } from './VirtualConnectionTableLineageCountsFragmentGql';

export const VirtualConnectionTableLineageCountsFilteredByColumnQueryGql: DocumentNode = gql`
query VirtualConnectionTableLineageCountsFilteredByColumnQuery(
  $vizportalUrlId: String!,
  $selectedColumnId: ID!
) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    ...VirtualConnectionTableLineageCountsFragment
    filteredColumnsConnection: columnsConnection(filter: { id: $selectedColumnId }) {
      nodes {
        name
        upstreamDatabasesConnection {
          totalCount
        }
        upstreamTablesConnection {
          totalCount
        }
        upstreamVirtualConnectionsConnection {
          totalCount
        }
        downstreamDatabasesConnection {
          totalCount
        }
        downstreamTablesConnection {
          totalCount
        }
        downstreamFlowsConnection {
          totalCount
        }
        downstreamDatasourcesConnection {
          totalCount
        }
        downstreamWorkbooksConnection {
          totalCount
        }
        downstreamDashboardsConnection {
          totalCount
        }
        downstreamSheetsConnection {
          totalCount
        }
        downstreamMetricsConnection {
          totalCount
        }
        downstreamOwnersConnection {
          totalCount
        }
      }
    }
  }
}
${VirtualConnectionTableLineageCountsFragmentGql}
`;
